import { environment as env } from "./environment.development-front";
import { EnvironmentsInterface } from "@ypa/types/environments";

export const environment: EnvironmentsInterface = {
    ...env,
    endpointMainPrefix: '',
    endpointAdditionalPrefix: ''
};
